(function () {
  function parseDiscounts(picker) {
    var map = {};
    var jsonEl = picker.querySelector('[skio-product-json]');
    if (!jsonEl) return map;
    try {
      var data = JSON.parse(jsonEl.textContent);
      (data.selling_plan_groups || []).forEach(function (group) {
        (group.selling_plans || []).forEach(function (plan) {
          var adjustment = plan.price_adjustments && plan.price_adjustments[0];
          map[String(plan.id)] = adjustment && adjustment.value_type === 'percentage' ? adjustment.value : null;
        });
      });
    } catch (e) {}
    return map;
  }

  function syncSelected(optionsWrap, select) {
    var cards = optionsWrap.querySelectorAll('.skio-deliver__card');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.toggle('skio-deliver__card--selected', cards[i].getAttribute('data-skio-plan') === select.value);
    }
  }

  function buildDeliver(label, content, select, discounts) {
    var deliverTemplate = document.getElementById('SkioDeliverTemplate');
    var cardTemplate = document.getElementById('SkioDeliverCardTemplate');
    if (!deliverTemplate || !cardTemplate || !deliverTemplate.content.firstElementChild) return;

    var deliver = deliverTemplate.content.firstElementChild.cloneNode(true);
    var optionsWrap = deliver.querySelector('.skio-deliver__options');
    var saveFormat = deliverTemplate.getAttribute('data-save-format') || 'Save {pct}%';

    var items = Array.prototype.slice.call(select.options).map(function (option) {
      return {
        value: option.value,
        label: option.textContent.trim().replace(/^Delivery\s+/i, ''),
        pct: discounts[String(option.value)]
      };
    });

    var best = items.reduce(function (current, item) {
      return item.pct != null && (current == null || item.pct > current.pct) ? item : current;
    }, null);

    items.sort(function (a, b) {
      return (b.pct == null ? 0 : b.pct) - (a.pct == null ? 0 : a.pct);
    });

    items.forEach(function (item) {
      var card = cardTemplate.content.firstElementChild.cloneNode(true);
      card.setAttribute('data-skio-plan', item.value);
      card.querySelector('.skio-deliver__name').textContent = item.label;

      var saveEl = card.querySelector('.skio-deliver__save');
      if (item.pct != null) {
        saveEl.textContent = saveFormat.replace('{pct}', item.pct);
      } else if (saveEl) {
        saveEl.remove();
      }

      var bestEl = card.querySelector('.skio-deliver__best');
      if (best && item.value === best.value) {
        card.classList.add('skio-deliver__card--best');
      } else if (bestEl) {
        bestEl.remove();
      }

      card.addEventListener('click', function (event) {
        event.stopPropagation();
        var liveSelect = label.querySelector('.skio-group-content select.skio-frequency') || select;
        if (liveSelect.value !== item.value) {
          liveSelect.value = item.value;
          liveSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncSelected(optionsWrap, liveSelect);
      });

      optionsWrap.appendChild(card);
    });

    content.insertAdjacentElement('afterend', deliver);
    syncSelected(optionsWrap, select);
  }

  function enhance(picker) {
    var discounts = parseDiscounts(picker);
    var oneTimeEl = picker.querySelector('[skio-onetime-price]');
    var originalPrice = oneTimeEl ? oneTimeEl.textContent.trim() : '';

    var containers = picker.querySelectorAll('.skio-group-container');

    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var input = container.querySelector('input.skio-group-input');
      if (!input || !input.hasAttribute('skio-selling-plan-group')) continue;

      var label = container.querySelector('.skio-group-label');
      var topline = label && label.querySelector('.skio-group-topline');
      if (!label || !topline) continue;

      var content = label.querySelector('.skio-group-content');
      var select = content && content.querySelector('select.skio-frequency');
      if (content && select) {
        var deliver = label.querySelector('.skio-deliver');
        var cardCount = deliver ? deliver.querySelectorAll('.skio-deliver__card').length : -1;
        if (!deliver || cardCount !== select.options.length) {
          if (deliver) deliver.remove();
          buildDeliver(label, content, select, discounts);
        } else {
          syncSelected(label.querySelector('.skio-deliver__options'), select);
        }
      }

      if (!label.querySelector('.skio-po-benefits')) {
        var benefitsTemplate = document.getElementById('SkioBenefitsTemplate');
        if (benefitsTemplate && benefitsTemplate.content.firstElementChild) {
          label.appendChild(benefitsTemplate.content.firstElementChild.cloneNode(true));
        }
      }

      var subscriptionPrice = topline.querySelector('[skio-subscription-price]');
      if (subscriptionPrice && originalPrice) {
        var compare = topline.querySelector('.skio-po-compare');
        if (!compare) {
          compare = document.createElement('s');
          compare.className = 'skio-po-compare';
          subscriptionPrice.insertAdjacentElement('afterend', compare);
        }
        if (compare.textContent !== originalPrice) {
          compare.textContent = originalPrice;
        }
      }
    }
  }

  function init() {
    var pickers = document.querySelectorAll('.skio-plan-picker');
    for (var i = 0; i < pickers.length; i++) {
      (function (picker) {
        enhance(picker);
        var observer = new MutationObserver(function () {
          enhance(picker);
        });
        observer.observe(picker, { childList: true, subtree: true });
      })(pickers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
